// Module
var code = "<div data-cy=\"{{$ctrl.name}}\"> <input type=\"hidden\" id=\"{{$ctrl.componentId}}\" style=\"width:100%\"/> </div> ";
// Exports
module.exports = code;